export default {
  arrowUp: 38,
  arrowDown: 40,
  enter: 13,
  escape: 27,
};
